import { Locale } from "@src/Enums/Locale"
import { tState } from "@src/Model/Model"
import { Select } from "@zeguro/component-library"
import * as React from "react"
import { useSelector } from "react-redux"
import { Props as IReactSelect } from "react-select"

type LocaleOption = { value: Locale; label: string }

const LOCALE_OPTIONS: LocaleOption[] = [
  { value: Locale.EN_US, label: "English" },
  { value: Locale.EN_CA, label: "English" },
  { value: Locale.FR_CA, label: "Français" },
]

interface ILocaleSelect {
  value: string
  onChange?: (locale: string) => void
  margin?: string
  maxWidth?: string
  menuPlacement?: IReactSelect["menuPlacement"]
}

export const LocaleSelect = ({
  value,
  onChange,
  margin,
  maxWidth,
  menuPlacement,
}: ILocaleSelect) => {
  const availableLocales = useSelector(
    (state: tState) => state.subscriptionId.availableLocales,
  )

  if (availableLocales.length < 2) {
    return null
  }

  const handleChange = (newLocale: LocaleOption) => {
    if (onChange) {
      onChange(newLocale.value)
    }
  }

  const filteredOptions = LOCALE_OPTIONS.filter((option) =>
    availableLocales.includes(option.value),
  )
  const selectedOption = filteredOptions.find((opt) => opt.value === value)

  return (
    <Select
      name="locale"
      isSearchable={false}
      options={filteredOptions}
      onChange={handleChange}
      value={selectedOption}
      margin={margin}
      maxWidth={maxWidth}
      menuPlacement={menuPlacement}
    />
  )
}
